/*
 * Información de la orden.
 *
 * Contiene el enlace para ir a la orden relacionada con la
 * devolución.
 *
 * Created on Mon Apr 17 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>
    <b-card class="border border-dark shadow-none">
      <div>
        <b-row>

          <!-- #region::Tittle -->
          <b-col class="align-self-end">
            <h4 class="font-weight-bolder">
              Información de la orden
            </h4>
          </b-col>
          <!-- #endregion::Tittle -->

          <!-- #region::Toggle button -->
          <b-button
            :variant="visible ? 'flat-primary' : 'flat-secondary'"
            class="btn-icon rounded-circle mr-1"
            @click="collapse"
          >
            <feather-icon :icon="iconToggle" />
          </b-button>
          <!-- #endregion::Toggle button -->

        </b-row>
      </div>

      <!-- #region::Collapsable content -->
      <b-collapse
        :id="collapseItemId"
        v-model="visible"
        role="tabpanel"
      >
        <b-row>

          <!-- #region::Order own -->
          <b-col md="4">
            <div class="d-flex">
              <div class="dot-blue text-center">
                <feather-icon
                  class="text-primary mt-50"
                  icon="ShoppingBagIcon"
                />
              </div>
              <div>
                <b-col class="ml-50">
                  <b-row cols="12">
                    <span class="align-self-center font-weight-bolder">Orden que pertenece</span>
                  </b-row>
                  <b-row cols="12">
                    <router-link
                      :to="{ name: 'order-details', params: { id: order.ID }}"
                    ><span class="text-nowrap">#{{ order.ID }}</span>
                    </router-link>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
          <!-- #endregion::Order own -->

          <!-- #region::Order creator -->
          <b-col
            v-if="$ability.can('read creator', 'Devolution')"
            md="4"
          >
            <div class="d-flex">
              <div class="dot-green text-center">
                <feather-icon
                  class="text-success mt-50"
                  icon="UserIcon"
                />
              </div>
              <div>
                <b-col class="ml-50">
                  <b-row cols="12">
                    <span class="align-self-center font-weight-bolder">Creada por</span>
                  </b-row>
                  <b-row cols="12">
                    <span>{{ creator.Name }}</span>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
          <!-- #endregion::Order creator -->

          <!-- #region::Order received at date -->
          <b-col
            v-if="canShowReceivedAtDate"
            md="4"
          >
            <div class="d-flex">
              <div class="dot-cian text-center">
                <feather-icon
                  class="text-info mt-50"
                  icon="CalendarIcon"
                />
              </div>
              <div>
                <b-col class="ml-50">
                  <b-row cols="12">
                    <span class="align-self-center font-weight-bolder">Recibida</span>
                  </b-row>
                  <b-row cols="12">
                    <span>{{ devolution.received_at | moment("DD/MM/YYYY hh:mm a") }}</span>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
          <!-- #endregion::Order received at date -->

        </b-row>
      </b-collapse>
      <!-- #endregion::Collapsable content -->

    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BRow, BCol, BCard, BButton, BCollapse,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BCollapse,
  },
  data() {
    return {
      visible: true,
      collapseItemId: '1',
      iconToggle: 'ChevronDownIcon',
    }
  },
  computed: {
    /**
     * Getters del estado de devoluciones
     */
    ...mapGetters({
      getRefund: 'refunds/getRefund',
    }),
    /**
     * Información global de la devolución
     */
    refund: {
      get() { return this.getRefund },
    },
    /**
     * Información específica de la devolución
     */
    devolution: {
      get() { return this.refund.devolution },
    },
    /**
     * Información de la orden de la devolución
     */
    order: {
      get() { return this.refund.devolution.order },
    },
    /**
     * Creador de la devolución
     */
    creator: {
      get() { return this.refund.devolution.user },
    },
    status: {
      get() { return this.refund.devolution.status.status },
    },
    canShowReceivedAtDate() {
      return this.status === 'Recibida'
      && this.devolution.received_at
      && this.$ability.can('read date', 'Devolution')
    },
  },
  methods: {
    collapse() {
      this.$root.$emit('bv::toggle::collapse', this.collapseItemId)
      this.visible = !this.visible
      this.setToggleIcon()
    },
    setToggleIcon() {
      this.iconToggle = this.visible ? 'ChevronUpIcon' : 'ChevronDownIcon'
    },
  },
}
</script>

<style lang="scss" scoped>
.dot-blue {
  height: 30px;
  width: 30px;
  background-color: #E5F0FF;
  border-radius: 50%;
  display: inline-block;
}
.dot-green {
  height: 30px;
  width: 30px;
  background-color: #e6ffe5;
  border-radius: 50%;
  display: inline-block;
}
.dot-cian {
  height: 30px;
  width: 30px;
  background-color: #CBF5FA;
  border-radius: 50%;
  display: inline-block;
}
</style>
